
const EnvType = {
	dev: 'DEV',
	uat: 'UAT',
	pro: 'PRO'
}

const GlobalConfig = {
	envType: EnvType.pro,
	isDebug: false,
	buildDate: '2023-12-25 17:30'
}

export {
	GlobalConfig,
	EnvType
}
